import './Dropup.scss'
import { isClientSide } from '@naturalcycles/js-lib'
import { useWindowScroll, useWindowSize } from '@uidotdev/usehooks'
import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'
import { NavLink } from '#src/components/NavLink.js'
import type { InternalLink } from '#src/data/data.js'
import { useClickOutside } from '#src/hooks/useClickOutside.js'
import { useKeyDown } from '#src/hooks/useKeyDown.js'

export interface DropupContent {
  title: string
  links: InternalLink[]
}

const showDropUpBelow = 200

interface Props {
  content: DropupContent
  showDropUpAbove: number
}

export function Dropup(props: Props): ReactNode {
  const { content, showDropUpAbove } = props
  const myRef = useRef(null)
  const [showMenu, setShowMenu] = useState(false)
  const [showDropUp, setShowDropUp] = useState(false)
  const [{ y }] = useWindowScroll()
  const { height: windowHeight } = useWindowSize()
  const bodyHeight = isClientSide() ? document.body.offsetHeight : 0 // todo: could be a hook

  useEffect(() => {
    // console.log({bodyHeight, windowHeight})
    const shouldBeShown =
      !!y &&
      !!windowHeight &&
      y >= showDropUpBelow &&
      y + windowHeight <= bodyHeight - showDropUpAbove
    // console.log({shouldBeShown})
    setShowDropUp(shouldBeShown)
    if (!shouldBeShown) {
      setShowMenu(false)
    }
  }, [y, bodyHeight, windowHeight, showDropUpAbove])

  useClickOutside(myRef, () => {
    setShowMenu(false)
  })

  useKeyDown('Escape', () => {
    setShowMenu(false)
  })

  function handleClick(): void {
    setShowMenu(!showMenu)
  }

  function handleNavClick(): void {
    setShowMenu(false)
  }

  return (
    <div className={`dropup ${showDropUp && 'dropup_opened'}`} ref={myRef}>
      <button
        className={clsx({
          'dropup__toggle-btn': true,
          'dropup__toggle-btn_opened': showMenu,
          'dropup__toggle-btn_full-opacity': showMenu,
        })}
        onClick={handleClick}
      >
        <div className="dropup__toggle-btn-arrow" />
        <p className="dropup__toggle-btn-title">{content.title}</p>
      </button>

      {showMenu && (
        <div className="dropup__menu">
          <ul className="dropup__menu-list">
            {content.links.map(link => (
              <NavLink
                href={link.url}
                key={link.url}
                scroll={true}
                onClick={handleNavClick}
                className="dropup__menu-link"
              >
                {link.text}
              </NavLink>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
